const TASK_TYPE_LABELS: Record<string, string> = {
  "source_control.repo_chat.retrieve.v1": "Repo Chat Retrieval",
};

export function formatTaskTypeLabel(taskType: string): string {
  return TASK_TYPE_LABELS[taskType] ?? taskType;
}

export function formatTaskTypeSuffixLabel(taskType: string): string {
  const exactLabel = TASK_TYPE_LABELS[taskType];
  if (exactLabel) {
    return exactLabel;
  }

  const dotIndex = taskType.indexOf(".");
  return dotIndex !== -1 ? taskType.substring(dotIndex) : taskType;
}
